module.exports = __webpack_public_path__ + "images/category_lp/common/icon-step1@2x_44d7464599543dcdacdd3aef3322005f.png";